import type { FC } from 'react'
import { I18nProvider } from '@lingui/react'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import RouterProvider from 'providers/RouterProvider'
import { CookiesProvider } from 'react-cookie'
import { HelmetProvider } from 'react-helmet-async'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { i18n } from '@lingui/core'

import store from './redux-store/store'

interface AppProvidersProps {
  children: React.ReactNode
}

export const AppProviders: FC<AppProvidersProps> = ({ children }) => {
  const queryClient = new QueryClient()

  return (
    <QueryClientProvider client={queryClient}>
      <CookiesProvider>
        <I18nProvider i18n={i18n}>
          <Provider store={store}>
            <HelmetProvider>
              <BrowserRouter>
                <RouterProvider>{children}</RouterProvider>
              </BrowserRouter>
            </HelmetProvider>
          </Provider>
        </I18nProvider>
      </CookiesProvider>
    </QueryClientProvider>
  )
}
